import { FC } from "react";
import { MainBarData } from "../../utils/pagesData";
import { MessengerIcon } from "./MessengerIcon/MessengerIcon";

import styles from "./FooterPage.module.scss";

interface FooterPageProps {
  mainInfo: MainBarData;
}

export const FooterPage: FC<FooterPageProps> = ({ mainInfo }) => {
  return (
    <footer className={styles.container}>
      <div className={styles.content}>
        <div className={styles.footerCol1}>
          <div className={styles.titleSmall}>Контакты</div>
          <div className={styles.info}>
            {mainInfo.contacts.map((c, ind) => (
              <div key={ind} className={styles.infoItem}>
                {c}
              </div>
            ))}
            {mainInfo.bookingOnline && (
              <div className={styles.infoItem}>
                <a href={mainInfo.bookingOnline} target="_blank">
                  Забронировать онлайн
                </a>
              </div>
            )}
          </div>
        </div>
        <div className={styles.footerCol2}>
          <div className={styles.titleBig}>{mainInfo.barName}</div>
          <div className={styles.communication}>
            {mainInfo.communication.map((m, ind) => (
              <MessengerIcon key={ind} messenger={m} />
            ))}
          </div>
        </div>
        <div className={styles.footerCol3}>
          <div className={styles.titleSmall}>Рабочее время</div>
          <div className={styles.info}>
            {mainInfo.workingTime.map((t, ind) => (
              <div key={ind} className={styles.infoItem}>
                {t}
              </div>
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
};
